export default class SeedGenerator {

    public seed(): string {
        const symbols = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
        const seed = [];
        for (let i = 0; i < 6; i++) {
            const index = Math.floor(Math.random() * (symbols.length - 1));
            seed.push(symbols[index]);
        }
        return seed.join('');
    }

}